export default __webpack_public_path__ + "static/slaughter-754871765a0e415a56392d53939f7bf9.png";